import { useState } from "react";
import { Bar } from "react-chartjs-2";


const StaffsSalesCounts = ({ data }) => {
    const barData = data
    const maxValue = Math.max(
        ...data.flatMap(item => {
            const staff = Object.values(item)[0];
            return [
                staff?.booked || 0,
                staff?.delivery || 0,
                staff?.pickup || 0
            ];
        })
    );

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Staff Performance Analysis",
                font: {
                    size: 20,
                    weight: "normal",
                    family: "Poppins, sans-serif",
                },
            },
        },

        scales: {
            x: {
                stacked: false,
                grid: {
                    display: false,
                },
            },
            y: {
                beginAtZero: true,
                suggestedMax: maxValue * 1.2, // 20% headroom
            },
        },
    };
    const barDataConvertor = (data = []) => {
        const colorPalette = [
            "#316aff",
            "#ff8111",
            "#01b5fa"
        ];

        const dataLabels = ["Booked", "Delivery", "Pickup"];

        const labels = data.map((item) => Object.keys(item)[0]);

        return {
            labels,
            datasets: dataLabels.map((label, index) => ({
                label,
                data: data.map((item) => {
                    const staffName = Object.keys(item)[0];
                    return item[staffName]?.[label.toLowerCase()] || 0;
                }),
                backgroundColor: colorPalette[index],
                datalabels: {
                    display: false
                }
            })),
        };
    };

    return (
        <div className="dashboard-bar-analytics p-3">
            <Bar
                options={barOptions}
                data={barDataConvertor(barData)}
            />
        </div>
    )
}

export default StaffsSalesCounts;